import React, {Component} from 'react';
import axios from '../../Axios/Axios.js'
import CTA_Link from '../../CTA_Link/CTA_Link.js';

import Jessie from './img/Jessie_Lemon.JPG';
import allDishes_Icon from './img/allDishes_Icon.png';

class Header extends Component{
    
    getCount(){
        if(this.props.plates){
            let count = this.props.plates.map(day => {
                return day.meals.length;
            });
            let sum = count.reduce((total, num)=>{
                return total+num;
            });
            if(sum > 21){
                sum = 21;
            }
            return sum;
        }
    }
    render(){
        return (
            <div className="PS_Header">
                <h2 className="shared_plan">Shared Plan</h2>
                <div className="row">
                    <img src={this.props.image} alt="PlateList Image" className="img_Jessie"/>
                    <div className="plateDiscription">
                        <h3 className="author">PlateList by {this.props.author}</h3>
                        <h1 className="plateList_title">{this.props.title}</h1>
    
                        <CTA_Link deskTop={this.props.deskTop} modalToggle={this.props.modalToggle} pageTag="Plate_Section_CTA" Class="btn" >
                            Grab PlateList
                        </CTA_Link>
                        <span  className="dish-count">
                            <img className="dish-icon" src={allDishes_Icon} alt="Dish Icon"/> {this.getCount()} Meals
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/Components/PlateSection/Header/Header.js